import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgNetherlandsFormal = (props)=>/*#__PURE__*/ _jsxs("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14.4 14.4",
        enableBackground: "new 0 0 14.4 14.4",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("style", {
                type: "text/css",
                children: "\n    .st0{fill:#FF4B55;}\n\t.st1{fill:#41479B;}\n\t.st2{fill:#F5F5F5;}\n  "
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "st0",
                d: "M11.7,0H2.7C1.2,0.2,0,1.5,0,3.1v1.7h14.4V3.1C14.4,1.5,13.2,0.2,11.7,0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "st1",
                d: "M0,11.2c0,1.7,1.4,3.1,3.2,3.1h8.1c1.7,0,3.2-1.4,3.2-3.1V9.6H0V11.2z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "st2",
                d: "M0,4.8h14.4v4.8H0V4.8z"
            }),
            /*#__PURE__*/ _jsx("g", {
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M5.8,8.9C5.5,8.6,5.3,8.1,5.3,7.5V5h1.1v2.5c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.2,0.6,0.2s0.5-0.1,0.6-0.2 C7.9,8.1,8,7.9,8,7.6V5h1.1v2.5c0,0.6-0.2,1.1-0.5,1.4C8.3,9.2,7.8,9.4,7.2,9.4C6.6,9.4,6.1,9.2,5.8,8.9z"
                })
            })
        ]
    });
export { SvgNetherlandsFormal };
